export default __webpack_public_path__ + "static/media/img-slider-lh-career-5.af9a3bdb.png";